import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { GroupingTagItemEntity } from '../../domain/grouping-tag-item.entity';
import {
	IGroupingTagListExtra,
	GroupingTagListEntity,
} from './grouping-tag-list.entity';

@Injectable()
export class GroupingTagListProvider {
	private groupingTagList: GroupingTagListEntity = GroupingTagListEntity.build(
		[]
	);

	public constructor() {}

	public getAvailableColumns(): Array<IGroupingTagListExtra> {
		const availableCols: Array<IGroupingTagListExtra> = [
			{
				field: 'label',
				alias: $localize`:@@dx.grid.column.label:`,
				type: 'string',
				isFilterable: true,
				isSearchable: true,
				hasHeaderFilter: false,
				canBeReordered: true,
				visibleIndex: 0,
			},
			{
				field: 'referencedByCount',
				alias: $localize`:@@groupingTag.grid.column.projRefCount:`,
				type: 'number',
				isFilterable: true,
				isSearchable: true,
				hasHeaderFilter: false,
				canBeReordered: false,
				visibleIndex: 1,
			},
			{
				field: 'createdBy',
				alias: $localize`:@@dx.grid.column.updatedBy:`,
				type: 'string',
				isFilterable: true,
				isSearchable: true,
				hasHeaderFilter: false,
				canBeReordered: true,
				visibleIndex: 2,
			},
			{
				field: 'createdOn',
				alias: $localize`:@@dx.grid.column.createdOn:`,
				type: 'datetime',
				isFilterable: true,
				isSearchable: true,
				hasHeaderFilter: false,
				canBeReordered: true,
				visibleIndex: 3,
			},
		];
		return availableCols;
	}

	public setList(cols: Array<IGroupingTagListExtra>): void {
		this.groupingTagList = GroupingTagListEntity.build(cols);
	}

	public setListElements(
		elements: Map<string, GroupingTagItemEntity>,
		total: number
	): GroupingTagListEntity {
		return this.groupingTagList.setElements(elements).setTotalItems(total);
	}
}
